import type { SupportedLocaleType } from '../../locales';
import { SUPPORTED_LOCALES } from '../../locales';
import { buildImgR2Key } from '../build-img-r2-key';
import { buildImgUrl } from '../build-img-url';
import {
  buildEnglishIqResultImgR2Key,
  buildEnglishIqResultImgUrl,
  ENGLISH_IQ_LANDING_IMG_SLUG,
  ENGLISH_IQ_RESULT_IMG_SCORES,
} from '../english-iq';

export interface IEnglishIqImgManifestCard {
  readonly locale: SupportedLocaleType;
  readonly r2Key: string;
  readonly slug: string;
  readonly type: 'english-iq-result' | 'page';
  readonly url: string;
}

export interface IEnglishIqImgManifest {
  readonly landing: readonly Readonly<IEnglishIqImgManifestCard>[];
  readonly results: readonly Readonly<IEnglishIqImgManifestCard>[];
}

export function buildEnglishIqImgManifest(): Readonly<IEnglishIqImgManifest> {
  const results = ENGLISH_IQ_RESULT_IMG_SCORES.flatMap((score) =>
    SUPPORTED_LOCALES.map((locale) =>
      Object.freeze({
        locale,
        r2Key: buildEnglishIqResultImgR2Key({ score, locale }),
        slug: String(score),
        type: 'english-iq-result' as const,
        url: buildEnglishIqResultImgUrl({ score, locale }),
      }),
    ),
  );
  const landing = SUPPORTED_LOCALES.map((locale) => {
    const args = { type: 'page' as const, slug: ENGLISH_IQ_LANDING_IMG_SLUG, locale };
    return Object.freeze({ ...args, r2Key: buildImgR2Key(args), url: buildImgUrl(args) });
  });
  return Object.freeze({ landing: Object.freeze(landing), results: Object.freeze(results) });
}
